import useInfiniteScroll from 'react-infinite-scroll-hook';
import { FormattedMessage } from 'react-intl';
import PullToRefresh from 'react-simple-pull-to-refresh';
import { isInStandaloneMode, isIos } from '../util/platform';

interface DefaultScrollList {
    loading: boolean;
    onLoadMore: () => void;
    hasMore: boolean;
    hasError: boolean;
    onRefresh: () => Promise<any>;
    children: React.ReactNode | React.ReactNode[];
}

export const CommonScrollList: React.FC<DefaultScrollList> = ({
    loading,
    onLoadMore,
    hasMore,
    hasError,
    onRefresh,
    children,
}) => {
    const [sentryRef] = useInfiniteScroll({
        loading: loading,
        hasNextPage: hasMore,
        onLoadMore: onLoadMore,

        // When there is an error, we stop infinite loading.
        // It can be reactivated by setting "error" state as undefined.
        disabled: hasError,

        // `rootMargin` is passed to `IntersectionObserver`.
        // We can use it to trigger 'onLoadMore' when the sentry comes near to become
        // visible, instead of becoming fully visible on the screen.
        rootMargin: '0px 0px 400px 0px',
    });

    const endOfInfiniteScrollListHiddenDiv = (
        <div
            aria-hidden={true}
            style={{ height: 0, width: 0, padding: 0, margin: 0 }}
            ref={sentryRef}
        />
    );

    return isIos() && isInStandaloneMode() ? (
        <PullToRefresh
            onRefresh={onRefresh}
            pullingContent={
                <h3 style={{ textAlign: 'center' }}>
                    &#8595;
                    <FormattedMessage
                        id="common.scroll.pull_down_refresh"
                        defaultMessage={' Pull down to refresh'}
                    />
                </h3>
            }
        >
            <div>
                {children}
                {(loading || hasMore) && endOfInfiniteScrollListHiddenDiv}
            </div>
        </PullToRefresh>
    ) : (
        <div>
            {children}
            {(loading || hasMore) && endOfInfiniteScrollListHiddenDiv}
        </div>
    );
};
